<div class="container-tig  bg-white">
    <div class="home-title">
        <h4>蒙古文无衬线报体</h4>
    </div>
    <div class=" cont-item text-center  home-t-item">
        <h4 class="font-oss home-t-item-2 mgl"> ᠮᠣᠩᠭᠣᠯ ᠪᠢᠴᠢᠭ ᠤᠨ ᠰᠣᠨᠢᠨ ᠲᠢᠭ</h4>
        <div class=" overflow-hidden">
            <div class=" d-flex justify-content-center font-oss text-details">
                <P class="mgl"> </P>
                <P class="mgl text-right" style="margin: 0 10px;">  </P>
                <P class="mgl" style="margin-right: 10px;">     
                    <br>      
                    <br>     
                    <br>      
                    <br>   
                    <br>    
                </P>
                <P class="mgl">
                       
                    <br>      
                    <br>    
                    <br>    
                    <br>   
                    <br>    
                </P>
            </div>
        </div>
    </div>
    <div class="home-cont">
        <div class="home-c-left">
            <p>
                1. 笔画舒展、线条流畅、笔画结构简单且紧凑。
                <br> 2. 单位面积信息量大、小屏幕小字号显示清晰、适应多终端。
            </p>
            <div class="home-D cont-item position-relative">
                <img src="./assets/images/ononTig.png" alt="Onon字体 - 蒙古文无衬线报体" class="img-border">
                <ul class="text-center">
                    <li>
                        <a class="xz-download text-center Download" [routerLink]="['/Download/1']" (click)="backToTop()">
                            <span class="d-text">
                                下载 
                            </span>
                            <span class="d-icon">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-down-short" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"/>
                                </svg>
                            </span>
                        </a>
                    </li>
                    <li style="margin: 5px 0;"><a [routerLink]="['/usageMethod/install']" (click)="backToTop()">安装指南</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="home-c-right">
            <div>
                <ul>
                    <li>
                        <a [routerLink]="['/aboutFonts']" (click)="backToTop()">
                            <span class="home-c-number">.01</span>
                            <p class="home-c-title">关于字体</p>
                        </a>
                    </li>
                    <li>
                        <a [routerLink]="['/process']" (click)="backToTop()">
                            <span class="home-c-number">.02</span>
                            <p class="home-c-title">研发过程</p>
                        </a>
                    </li>
                    <li>
                        <a [routerLink]="['/characteristic']" (click)="backToTop()">
                            <span class="home-c-number">.03</span>
                            <p class="home-c-title">特点</p>
                        </a>
                    </li>
                    <li>
                        <a [routerLink]="['/authorize']" (click)="backToTop()">
                            <span class="home-c-number">.04</span>
                            <p class="home-c-title">授权</p>
                        </a>
                    </li>
                    <li>
                        <a [routerLink]="['/cooperation']" (click)="backToTop()">
                            <span class="home-c-number">.05</span>
                            <p class="home-c-title">使用方法</p>
                        </a>
                    </li>
                    <li>
                        <a [routerLink]="['/cooperation']" (click)="backToTop()">
                            <span class="home-c-number">.06</span>
                            <p class="home-c-title">合作</p>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <br>
    <br>
</div>